import './StatusChip.scss';

import cn from 'classnames';
import { ComponentProps, ReactElement } from 'react';

import { ForecastStatus } from '@blisspointmedia/bpm-types/dist/Forecasting';

import { Button } from '../../../Components/Button/Button';
import { Design, Size } from '../../../Components/designConstants';

interface StatusChipProps extends Omit<ComponentProps<typeof Button>, 'design'> {
  status: ForecastStatus;
}

const statusToPrettyLabel = (status: ForecastStatus): string => {
  switch (status) {
    case 'In Progress':
      return 'Processing';
    case 'Completed':
      return 'Live';
    default:
      return status;
  }
};

const StatusChip = ({
  status,
  size = Size.LG,
  className,
  ...buttonProps
}: StatusChipProps): ReactElement => (
  <Button
    {...buttonProps}
    size={size}
    className={cn(
      'status-chip',
      `status-chip-${status.toLowerCase().replace(/\s+/g, '-')}`,
      className
    )}
    design={Design.NEUTRAL}
  >
    {statusToPrettyLabel(status)}
  </Button>
);

export { StatusChip };
